// extracted by mini-css-extract-plugin
export default {"contactUs":"Contact_contactUs__J+xjB","aboutHeading":"Contact_aboutHeading__8m70N","contactDiv":"Contact_contactDiv__9OeZO"};